import { useAuth0 } from '@auth0/auth0-react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import GenericLoading from '../../components/GenericLoading'
import { HomePageProvider } from '../../context/HomePageProvider'
import { useOrgSettings } from '../../context/OrgSettingsProvider'
import { useParentParts } from '../../hooks/queries/useParentParts'
import { useProjects } from '../../hooks/queries/useProjects'
import CTBPartsTable from './sections/CTBPartsTable'
import CTBTable from './sections/CTBTable'
import DeliveriesHomePage from './sections/DeliveriesHomePage'
import HomeTopRow from './sections/HomePageTopRow'
import PartRisksTable from './sections/PartRisksTable'
import PoPlanningTable from './sections/PoPlanningTable'
import ProductionForecast from './sections/ProductionForecast'
import { API_URL } from '../../config'

const useStyles = makeStyles(() => ({
  outerContainer: {
    padding: 20,
    paddingTop: 40,
  },
}))
const HomePage = () => {
  const classes = useStyles()

  const [parentPart, setParentPart] = useState()
  const { homePageTables } = useOrgSettings()
  const queryClient = useQueryClient()
  const [parentPartList, setParentPartList] = useState([])
  const { user } = useAuth0()
  const ppQuery = useParentParts(setParentPart, setParentPartList, user?.email)

  const [project, setProject] = useState()
  const [allProjects, setAllProjects] = useState([])
  const pjQuery = useProjects(setAllProjects, parentPart?.partNumber, user?.email)

  useEffect(() => {
    if (parentPart && allProjects.length > 0) {
      let localselectedProject = user?.email ? localStorage.getItem(`${user?.email}selectedProject`) : ''
      const foundProject = localselectedProject && allProjects.find((proj) => proj === localselectedProject)
      if (foundProject) {
        setProject(foundProject)
      } else {
        setProject(allProjects[0])
      }
    }
  }, [allProjects, user?.email, parentPart]);

  useEffect(() => {
    if (user?.email && parentPart && parentPart?.partNumber !== JSON.parse(localStorage.getItem(`${user?.email}parentPart`))?.partNumber) {
      localStorage.setItem(`${user?.email}parentPart`, JSON.stringify(parentPart))
    }
    if (allProjects.length > 0) {
      if (user?.email && project !== undefined && project !== null && project !== localStorage.getItem(`${user?.email}selectedProject`)) {
        localStorage.setItem(`${user?.email}selectedProject`, project)
      }
    }
  }, [parentPart, project, user?.email])

  useEffect(() => {
    if (user) axios.defaults.headers.common['Authorization'] = user?.email
  }, [user])

  if (ppQuery.isLoading || pjQuery.isLoading) {
    return (
      <Grid container direction='row' spacing={1} alignItems='center' justifyContent='center'>
        <Grid item>
          <GenericLoading />
        </Grid>
      </Grid>
    )
  }

  const refreshDeliveryTableData = () => {
    queryClient.refetchQueries(['deliveryTable'])
    queryClient.refetchQueries(['allDeliveries'])
    queryClient.refetchQueries(['recentDeliveries'])
  }

  return (
    <Container maxWidth='md' className={classes.outerContainer}>
      {ppQuery.isFetching ? null : (
        <HomeTopRow
          setParentPart={setParentPart}
          parentParts={parentPartList}
          parentPart={parentPart}
          selectedProject={project}
          setProject={setProject}
          projects={allProjects}
        />
      )}

      {homePageTables?.productionForecast === true && <ProductionForecast project={project} parentPart={parentPart} />}
      {homePageTables?.ctbTable === true && <CTBTable project={project} parentPart={parentPart} />}
      {homePageTables?.ctbPartOverviewTable === true && <CTBPartsTable project={project} parentPart={parentPart} />}
      {homePageTables?.poPlanningTable === true && <PoPlanningTable project={project} parentPart={parentPart} />}
      {homePageTables?.supplyChainRiskAnalysisTable === true && <PartRisksTable />}
      {homePageTables?.upcommingDeliveriesTable === true && (
        <DeliveriesHomePage
          project={project}
          parentPart={parentPart}
          heading='Recent and Upcoming Deliveries'
          refreshTableData={refreshDeliveryTableData}
        />
      )}
    </Container>
  )
}

const HomePageWithProvider = () => (
  <HomePageProvider>
    <HomePage />
  </HomePageProvider>
)

export default HomePageWithProvider
